import React, { useState, useEffect } from 'react';
import './page-title.css';

const PageTitle = () => {
  const [title, setTitle] = useState('');

  useEffect(() => {
    const name = localStorage.getItem('activeTournamentName') || '';
    setTitle(name);
  }, []);

  return (
    <h1 className="page-title">
      {title ? `${title} Prediction Leaderboard` : 'Prediction Leaderboard'}
    </h1>
  );
};

export default PageTitle;
